module.exports = __webpack_public_path__ + "img/点餐系统.7f970f3b.png";